import { Text, Box, HStack, VStack, useMediaQuery } from "native-base";
import DividerLine from "../../components/divider";
import { travelPartnerNameSVG } from "../../utils/svg";
import { COLORS } from "../../utils/colors";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";
import ContainerCards from "../../components/cards";
import { Svg } from "react-native-svg";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import "./style.css";

const PartnerDetails = ({ contactDetails = "" }) => {
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });

  return (
    <Box pb={3} width={"100%"}>
      <HStack
        space={5}
        width={"100%"}
        direction={MobileWindow ? "column" : "row"}
      >
        {contactDetails.map((item) => {
          return (
            <ContainerCards
              width={MobileWindow ? "100%" : "auto"}
              height="auto"
              minH="75px"
              borderRadius="8px"
              border={"0.8px solid " + COLORS.ATTACHMENT_FILES_BORDER_COLOR}
              background={COLORS.TRAVEL_PARTNERS_CARD_BGCOLOR}
              boxShadow="0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
            >
              <VStack p={3.5} pr={MobileWindow ? 1 : undefined} width={"100%"}>
                <HStack space={2.5} alignItems={"center"}>
                  <Svg width="16" height="16" viewBox="0 0 16 16">
                    {travelPartnerNameSVG}
                  </Svg>
                  <Text
                    fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
                    color={COLORS.PARTNERS_HEADING_COLOR}
                  >
                    {item.contactName}
                  </Text>
                </HStack>
                <HStack pt={2.5} flexWrap={"wrap"}>
                  {MobileWindow ? (
                    item.emailId.length > 1 ? (
                      <div className="grid-container">
                        {item.emailId?.map((email, ind) => {
                          return (
                            <>
                              <div className={"d-grid"}>
                                <Text
                                  color={COLORS.ATTACHMENTS_TEXT_COLOR}
                                  fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                                  fontWeight={
                                    COMMONFONTWEIGHT.SMALL_FONT_WEIGHT
                                  }
                                >
                                  {email}
                                </Text>
                                {(ind === 0 || ind === 2) && (
                                  <DividerLine
                                    direction="vertical"
                                    height="16px"
                                  />
                                )}
                              </div>
                            </>
                          );
                        })}
                      </div>
                    ) : (
                      item.emailId?.map((email) => {
                        return (
                          <>
                            <Text
                              color={COLORS.ATTACHMENTS_TEXT_COLOR}
                              fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                              fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
                            >
                              {email}
                            </Text>
                          </>
                        );
                      })
                    )
                  ) : (
                    item.emailId?.map((email, ind) => {
                      return (
                        <>
                          <Text
                            color={COLORS.ATTACHMENTS_TEXT_COLOR}
                            fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                            fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
                          >
                            {email}
                          </Text>
                          {!MobileWindow && ind + 1 != item.emailId.length && (
                            <DividerLine direction="vertical" height="16px" />
                          )}
                        </>
                      );
                    })
                  )}
                </HStack>
              </VStack>
            </ContainerCards>
          );
        })}
      </HStack>
    </Box>
  );
};

export default PartnerDetails;
